import {
    ActionTypes
} from "../type";

export const showObservationRanges = (value) => async (dispatch) => {
    try {
        dispatch({
            type: ActionTypes.SHOW_OBSERVATION_RANGE_FORM,
            payload: value
        })
    } catch (err) {
        throw (err)
    }
}

export const setObservationRangeData = (data) => async (dispatch) => {
    try {
        dispatch({
            type: ActionTypes.SET_OBSERVATION_RANGE_FORM_DATA,
            payload: data
        })
    } catch (err) {
        throw (err)
    }
}

export const setInternalObservationOpen = (value) => async (dispatch) => {
    try {
        dispatch({
            type: ActionTypes.SET_IS_INTERNAL_OBSERVATION_OPEN,
            payload: value
        })
    } catch (err) {
        throw (err)
    }
}